import { lazy } from 'react';

import type { RouteDefinition } from 'common/types/route';
import { DCR_DASHBOARD_PERMISSIONS, DCR_DASHBOARD_ROLES } from 'common/utils/dcrConstants';

export const routes: RouteDefinition[] = [
    {
        component: lazy(() => import('module/dcrDashboard/DcrDashboardPage')),
        permissions: DCR_DASHBOARD_PERMISSIONS,
        role: DCR_DASHBOARD_ROLES,
        path: '/dcrDashboard',
        studyOnlyRequired: true,
    },
];
